module.exports = __webpack_public_path__ + "img/la2.3eabca64.png";